export default Object.freeze({
    DestrezasSocioemocionales: 28,
    DatosAccesoATEscuela: 29
})